import React from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';
import { i18, trb } from 'src/Utilities';

interface IProps extends LinkProps {
  'aria-label'?: string;
}

export const Link: React.FC<IProps> = (props) => {
  const { children, 'aria-label': ariaLabel, target, ...restProps } = props;

  return (
    <RouterLink
      {...restProps}
      target={target}
      aria-label={ariaLabel && target === '_blank' ? `${ariaLabel} (${trb(i18.Accessibility.OpensInNewTab)})` : ariaLabel}
    >
      {children}
    </RouterLink>
  );
};
